export const getIsAuthenticated = (state) => state.auth.isAuthenticated;
export const getIsSignUp = (state) => state.auth.isSignUp;
export const getUser = (state) => state.auth.user;
export const getToken = (state) => state.auth.token;
export const getEmail = (state) => state.chart.user.email;

export const getUserLastName = (state) => state.auth.user.last_name;
export const getUserFirstName = (state) => state.auth.user.first_name;
export const getUserName = (state) => state.chart.user.name;

export const loadInitClientDataFail = (state) => state.auth.fail;



export const getError = (state) => state.auth.error;
// export const getProject = (state) => state.chart.user.name;

export const getUserAccounts = (state) =>
  state.auth.user ? state.auth.user : [];
